export function getObjectFromLocalStorage<T extends object>(key: string): T {
  const value = localStorage.getItem(key);
  if (value == null) return null;
  const parsed = JSON.parse(value);
  if (typeof parsed !== "object") {
    console.warn(
      "Expected type 'object' from local storage, got: " + typeof parsed,
    );
    return null;
  }
  return parsed;
}
